<scaffold-dialog [title]="'Edit' + item?.label" [fit]="true">
  <div scaffoldDialogBody>
    <div *ngFor="let sel of selectedItem[item.param];let i =index" class="de-subsetting de-fade flex-list control-item">
      <span class="control-move-buttons control-buttons">
        <p-button variant="text" severity="link" [disabled]="i===0" title="Move {{item.label}} up" (click)="moveItem(sel,selectedItem[item.param],i,-1)"><i class="fas fa-arrow-up"></i></p-button>
        <p-button variant="text" severity="link" [disabled]="i===selectedItem[item.param].length - 1" title="Move {{item.label}}" (click)="moveItem(sel,selectedItem[item.param],i,2)"><i class="fas fa-arrow-down"></i></p-button>
      </span>
      <div style="flex-grow:2;">
        <app-controls *ngFor="let control of item.settings" [item]="control" [selectedItem]="sel" [rootItem]="selectedItem" [parentView]="parentView"  (closeDialog)="optionsUpdate($event)" (setProperty)="updateOptions($event)"></app-controls>
      </div>
      <span class="control-buttons">
        <p-button variant="text" severity="link" title="Remove {{item.label}}" (click)="selectedItem[item.param].splice(i, 1)"><i class="fat fa-trash-alt"></i></p-button>
      </span>
    </div>
    <button pButton severity="primary" (click)="arrayLength(selectedItem, item.param, 1, item.defaults)">{{'add'| translation}} {{item.label}}</button>
  </div>
  <div scaffoldDialogButtons>
    <button pButton severity="primary" (click)="dialogRef.close()">{{'close'| translation}}</button>
  </div>
</scaffold-dialog>
